import { Col, Divider, Row } from 'antd';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormRadio } from 'presentation/components/form/FormRadio.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import getMessage from 'utilities/constants/MESSAGE';

interface props {
    masterData: any;
    requireOccupationOthers: boolean,
    setRequireOccupationOthers: (value: boolean) => void,
    changeBtnDisable: (isError?: boolean) => void,
    requireHouseOthers: boolean,
    setRequireHouseOthers: (value: boolean) => void,
    form: any
}

const FormRegisInfomantion = ({
    masterData,
    requireOccupationOthers,
    setRequireOccupationOthers,
    changeBtnDisable,
    requireHouseOthers,
    setRequireHouseOthers,
    form
}: props) => {
    return (
        <>
            <span className="content-step-form heading-step-form">基本情報</span>
            <Divider className="mb-6 my-1" />
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormInput
                        label="ニックネーム"
                        required
                        name="nickName"
                        size={'large'}
                        maxLength={20}
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
                <Col span={12} className="pl-[12px]">
                    <FormInput
                        required
                        label="メールアドレス"
                        size={'large'}
                        name="email"
                        maxLength={100}
                        type="email"
                        labelClassName="content-step-form label-step-form"
                        rules={[
                            {
                                type: 'email',
                                message: getMessage('Mail_Invalid'),
                            },
                        ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormSelect
                        options={masterData?.[MASTER_CATEGORY_LIST.USER_AGE_CLASSIFICATION]}
                        label="年代"
                        required
                        name="age"
                        size={'large'}
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
                <Col span={12} className="pl-[12px]">
                    <FormInput
                        suffix={'人'}
                        required
                        type="number"
                        maxLength={2}
                        label="同居家族の人数"
                        size={'large'}
                        name="livingWithFamilyCount"
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormSelect
                        options={masterData?.[MASTER_CATEGORY_LIST.MARITAL_STATUS_CLASSIFICATION]}
                        label="現在の婚姻ステータス"
                        required
                        name="maritalStatus"
                        size={'large'}
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
                <Col span={12} className="pl-[12px]">
                    <FormInput
                        suffix={'人'}
                        required
                        type="number"
                        maxLength={2}
                        label="子供の人数"
                        size={'large'}
                        name="childrenCount"
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormSelect
                        options={
                            masterData?.[MASTER_CATEGORY_LIST.OCCUPATION_CATEGORY_CLASSIFICATION]
                        }
                        label="職業"
                        required
                        name="occupationCategory"
                        size={'large'}
                        labelClassName="content-step-form label-step-form"
                        onChange={(e) => {
                            setRequireOccupationOthers(e == '99')
                        }}
                    />
                </Col>
                <Col span={12} className="pl-[12px]">
                    <FormInput
                        required={requireOccupationOthers}
                        disabled={!requireOccupationOthers}
                        label="職業その他"
                        maxLength={20}
                        size={'large'}
                        name="occupationOthers"
                        labelClassName="content-step-form label-step-form"
                        currentForm={form}
                        onValidateError={changeBtnDisable}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormSelect
                        options={
                            masterData?.[MASTER_CATEGORY_LIST.ANNUAL_INCONME_RANGE_CLASSIFICATION]
                        }
                        label="年収"
                        required
                        name="annualIncomeRange"
                        size={'large'}
                        labelClassName="content-step-form label-step-form"
                    />
                </Col>
                <Col span={12} className="pl-[12px]">
                    <FormSelect
                        options={masterData?.[MASTER_CATEGORY_LIST.HOUSE_TYPE_CLASSIFICATION]}
                        label="居住環境"
                        required
                        name="houseType"
                        size={'large'}
                        labelClassName="content-step-form label-step-form"
                        onChange={(e) => {
                            setRequireHouseOthers(e == '99')
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormInput
                        required={requireHouseOthers}
                        disabled={!requireHouseOthers}
                        maxLength={20}
                        label="居住環境その他"
                        size={'large'}
                        name="houseOthers"
                        labelClassName="content-step-form label-step-form"
                        currentForm={form}
                        onValidateError={changeBtnDisable}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={12} className="pr-[12px]">
                    <FormRadio
                        options={
                            masterData?.[MASTER_CATEGORY_LIST.HOUSING_LOAN_EXISTS_CLASSIFICATION]
                        }
                        name="housingLoanExists"
                        label="ローン有無"
                        required
                    />
                </Col>

                <Col span={12} className="pl-[12px]">
                    <FormRadio
                        options={
                            masterData?.[
                                MASTER_CATEGORY_LIST.INVESMENT_PROPERTY_EXISTS_CLASSIFICATION
                            ]
                        }
                        name="investmentPropertyExists"
                        label="投資用不動産所有有無"
                        required
                    />
                </Col>
            </Row>
        </>
    );
};
export default FormRegisInfomantion;
